import { render, staticRenderFns } from "./CurrentStatuses.vue?vue&type=template&id=9b2015e2&scoped=true&"
import script from "./CurrentStatuses.vue?vue&type=script&lang=js&"
export * from "./CurrentStatuses.vue?vue&type=script&lang=js&"
import style0 from "./CurrentStatuses.vue?vue&type=style&index=0&id=9b2015e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2015e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VContainer,VDataTable,VRow,VTooltip})
